"use client";

import navLinks from "@/app/data/navLinks";
import { Divider, Link, Listbox, ListboxItem, NavbarItem } from "@heroui/react";
import { usePathname } from "next/navigation";
import clsx from "clsx";
import { Session } from "@/app/interfaces/session";
import { access } from "@/app/lib/roles";

const NavbarLinks = ({
  sidebar,
  fPanelAccess,
  fractionId,
  session
}: {
  sidebar?: boolean;
  fPanelAccess?: boolean;
  fractionId?: string;
  session?: Session;
}) => {
  const pathname = usePathname();

  return (
    <>
      {navLinks.map((link) => {
        const isActive = link.href === pathname;

        return (
          <NavbarItem key={link.label} isActive={isActive}>
            <Link
              aria-current={isActive ? "page" : undefined}
              size={sidebar ? "lg" : "sm"}
              color={isActive ? "secondary" : "foreground"}
              href={link.href}
              target={link.target}
              className={clsx(sidebar && "w-full")}>
              {link.label.toLocaleUpperCase()}
            </Link>
          </NavbarItem>
        );
      })}
      {sidebar && pathname?.includes("/fractionspanel") && (
        <>
          <Divider />
          <Listbox>
            {
              access.fractions.includes(session?.user.role as string) ? (
                <ListboxItem
                  as={Link}
                  href='/fractionspanel'
                  key='fractionspanel'
                  variant='faded'
                  className={`text-foreground ${'/fractionspanel' === pathname && 'text-primary'}`}>
                    Panel
                </ListboxItem>
              ) : null
            }
            <ListboxItem
              as={Link}
              href={`/fractionspanel/${fractionId}`}
              key='fractionspanel:fractionid'
              variant='faded'
              className={`text-foreground ${pathname.includes('/fractionspanel/:id') && 'text-primary'}`}>
                Strona główna
            </ListboxItem>
            <ListboxItem
              as={Link}
              href={`/fractionspanel/${fractionId}/roles`}
              key='roles'
              variant='faded'
              className={`text-foreground ${pathname.includes('/roles') && 'text-primary'}`}>
                Role
            </ListboxItem>
            <ListboxItem
              as={Link}
              href={`/fractionspanel/${fractionId}/members`}
              key='members'
              variant='faded'
              className={`text-foreground ${pathname.includes('/members') && 'text-primary'}`}>
                Członkowie
            </ListboxItem>
            <ListboxItem
              as={Link}
              href={`/fractionspanel/${fractionId}/reports`}
              key='reports'
              variant='faded'
              className={`text-foreground ${pathname.includes('/reports') && 'text-primary'}`}>
                Raporty
            </ListboxItem>
            <ListboxItem
              as={Link}
              href={`/fractionspanel/${fractionId}/persons`}
              key='persons'
              variant='faded'
              className={`text-foreground ${pathname.includes('/persons') && 'text-primary'}`}>
                Baza stalkerów
            </ListboxItem>
            <ListboxItem
              as={Link}
              href={`/fractionspanel/${fractionId}/groups`}
              key='groups'
              variant='faded'
              className={`text-foreground ${pathname.includes('/groups') && 'text-primary'}`}>
                Baza grup
            </ListboxItem>
            <ListboxItem
              as={Link}
              href={`/fractionspanel/${fractionId}/trades`}
              key='trade'
              variant='faded'
              className={`text-foreground ${pathname.includes('/trades') && 'text-primary'}`}>
                Handel
            </ListboxItem>
            <ListboxItem
              as={Link}
              href={`/fractionspanel/${fractionId}/quests`}
              key='quests'
              variant='faded'
              className={`text-foreground ${pathname.includes('/quests') && 'text-primary'}`}>
                Zadania
            </ListboxItem>
            <ListboxItem
              as={Link}
              href={`/fractionspanel/${fractionId}/predefined`}
              key='predefined'
              variant='faded'
              className={`text-foreground ${pathname.includes('/predefined') && 'text-primary'}`}>
                Predefiniowane
            </ListboxItem>
            <ListboxItem
              as={Link}
              href={`/fractionspanel/${fractionId}/logs`}
              key='logs'
              variant='faded'
              className={`text-foreground ${pathname.includes('/logs') && 'text-primary'}`}>
                Logi
            </ListboxItem>
            <ListboxItem
              as={Link}
              href={`/fractionspanel/${fractionId}/settings`}
              key='settings'
              variant='faded'
              className={`text-foreground ${pathname.includes('/settings') && 'text-primary'}`}>
                Ustawienia
            </ListboxItem>
          </Listbox>
        </>
      )}
    </>
  );
};

export default NavbarLinks;
